module.exports = __webpack_public_path__ + "img/06.4d02e466.jpg";